/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.14.0
 * @since 1.13.0
 */

import { useState } from 'react';

import classNames from 'classnames';
import { useSelector } from 'react-redux';

import { Button } from '../../../components/common';
import { ImgStatusError } from '../../../components/common/Block/Img';
import ArrowTooltip from '../../../components/common/Tooltip/Tooltip';
import { makeSelectPageSubscriberIdTranslation } from '../../../modules/internationalization/intSelectors';
import { SubscriberIdErrorStyled } from './styled/SubscriberIdErrorStyled';


interface ISubscriberIdError {
    left?: boolean;
    withoutImage?: boolean;
    refetch: () => void;
}

const SubscriberIdError = ({ left, withoutImage, refetch }: ISubscriberIdError) => {

    const [disabled, setDisabled] = useState(false);

    const translationSubscriberId = useSelector(makeSelectPageSubscriberIdTranslation());

    const onBtnClickHandler = () => {
        refetch();
        setDisabled(true);
        setTimeout(() => {
            setDisabled(false);
        }, 5000);
    };

    return (
        <SubscriberIdErrorStyled className={classNames({
            'subscriber-id-error_left': left,
            'subscriber-id-error_center': !left,
        })}>
            {
                !withoutImage && <ImgStatusError/>
            }
            <div className="subscriber-id-error__title">
                {translationSubscriberId.error.title}
            </div>
            <ArrowTooltip
                disableHoverListener={!disabled}
                placement="top"
                title={translationSubscriberId.error.tooltip}
            >
                <span style={{ width: 'fit-content' }}>
                    <Button
                        disabled={disabled}
                        kind={withoutImage ? 'mediumNormal' : 'medium'}
                        onClick={onBtnClickHandler}
                    >
                        {translationSubscriberId.error.btn}
                    </Button>
                </span>
            </ArrowTooltip>
        </SubscriberIdErrorStyled>
    );
};

export default SubscriberIdError;
